import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { QA } from "@/lib/constants";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

interface QAItemProps {
  qa: QA;
}

export function QAItem({ qa }: QAItemProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card className="mb-4">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">{qa.question}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-sm text-gray-500 mb-2">{qa.summary}</div>

        {expanded ? (
          <div className="mt-2 text-gray-700 whitespace-pre-wrap">
            {qa.answer}
          </div>
        ) : (
          <div className="mt-2 text-gray-700 line-clamp-3">{qa.answer}</div>
        )}

        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-2 flex items-center text-sm text-purple-600 hover:text-purple-800"
        >
          {expanded ? (
            <>
              <ChevronUp className="h-4 w-4 mr-1" />
              Show less
            </>
          ) : (
            <>
              <ChevronDown className="h-4 w-4 mr-1" />
              Read full answer
            </>
          )}
        </button>
      </CardContent>
    </Card>
  );
}
